import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '../../../node_modules/@ng-bootstrap/ng-bootstrap';
import { MyRiskListComponent } from './my-risk-list/my-risk-list.component';
import { RouterModule } from '@angular/router';
import { RiskDetailsComponent } from './risk-details/risk-details.component';
import { RiskImpactComponent } from './risk-impact/risk-impact.component';
import { MitigatingActionComponent } from './mitigating-action/mitigating-action.component';
import { MitigatingActionListComponent } from './mitigating-action-list/mitigating-action-list.component';
import { RiskEventListComponent } from './risk-event-list/risk-event-list.component';
import { RiskEventComponent } from './risk-event/risk-event.component';
import { RiskImpactListComponent } from './risk-impact-list/risk-impact-list.component';
import { EmergingRisksComponent } from './emerging-risks/emerging-risks.component';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

// Import angular-fusioncharts
import { FusionChartsModule } from "../../../node_modules/angular-fusioncharts";

// Import FusionCharts library and chart modules
import * as FusionCharts from '../../../node_modules/fusioncharts';
import * as Charts from '../../../node_modules/fusioncharts/fusioncharts.charts';
import * as PowerCharts from '../../../node_modules/fusioncharts/fusioncharts.powercharts';
import * as FusionTheme from '../../../node_modules/fusioncharts/themes/fusioncharts.theme.fusion';
import { MyRiskEventListComponent } from './my-risk-event-list/my-risk-event-list.component';
import { MyMitigatingActionListComponent } from './my-mitigating-action-list/my-mitigating-action-list.component';
import { MitigationEditorComponent } from './mitigation-editor/mitigation-editor.component';
import { RiskEventEditorComponent } from './risk-event-editor/risk-event-editor.component';
import { PolicyGuidelineListComponent } from './policy-guideline-list/policy-guideline-list.component';
import { PolicyGuidelineComponent } from './policy-guideline/policy-guideline.component';
import { AddRiskComponent } from './add-risk/add-risk.component';
import { EditRiskComponent } from './edit-risk/edit-risk.component';
import { MitigationReviewComponent } from './mitigation-review/mitigation-review.component';
import { AddUserComponent } from './add-user/add-user.component';
import { EditUserComponent } from './edit-user/edit-user.component';
import { UserListComponent } from './user-list/user-list.component';
import { RiskListComponent } from './risk-list/risk-list.component';
import { StrategicRiskDashboardComponent } from './strategic-risk-dashboard/strategic-risk-dashboard.component';
import { RiskReportsComponent } from './risk-reports/risk-reports.component';
import { RiskAuditListComponent } from './risk-audit-list/risk-audit-list.component';
import { RiskAuditDetailsComponent } from './risk-audit-details/risk-audit-details.component';
import { HorizonScanningComponent } from './horizon-scanning/horizon-scanning.component';
import { HorizonScanningDetailComponent } from './horizon-scanning-detail/horizon-scanning-detail.component';
import { HorizonScanningAddComponent } from './horizon-scanning-add/horizon-scanning-add.component';
import { EscalatedRiskListComponent } from './escalated-risk-list/escalated-risk-list.component';
import { AddEscalatedRiskComponent } from './add-escalated-risk/add-escalated-risk.component';
import { EditEscalatedRiskComponent } from './edit-escalated-risk/edit-escalated-risk.component';
import { RiskService } from '../shared/services/risk.service';
import { RiskCacheService } from '../shared/services/risk-cache.service';
import { RiskProbabilityPipe } from '../shared/pipes/risk-probability.pipe';
import { RiskImpactPipe } from '../shared/pipes/risk-impact.pipe';
import { MitigationReviewFormComponent } from './mitigation-review-form/mitigation-review-form.component';

// Pass the fusioncharts library and chart modules
FusionChartsModule.fcRoot(FusionCharts, Charts, FusionTheme, PowerCharts);

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    FusionChartsModule,
    RouterModule.forChild([
      { path: 'list', component: MyRiskListComponent },
      { path: 'details/:id', component: RiskDetailsComponent },
      { path: 'audit/:id', component: RiskAuditListComponent },
      { path: 'audit-entry/:id', component: RiskAuditDetailsComponent },
      { path: 'add-risk', component: AddRiskComponent },
      { path: 'edit-risk/:id', component: EditRiskComponent },
      { path: 'riskevents/:id', component: RiskEventComponent },
      { path: 'riskmitigations/:id', component: MitigatingActionComponent },
      { path: 'riskmitigations/:mitigationId/review', component: MitigationReviewComponent },
      { path: 'riskmitigations/:mitigationId/review/:reviewId', component: MitigationReviewComponent },
      { path: 'risk-impacts', component: RiskImpactListComponent },
      { path: 'risk-events', component: MyRiskEventListComponent },
      { path: 'risk-mitigations', component: MyMitigatingActionListComponent },
      { path: 'emerging-risks', component: EmergingRisksComponent },
      //{ path: 'policy-guidelines', component: PolicyGuidelineListComponent },
      //{ path: 'policy-guidelines/:id', component: PolicyGuidelineComponent },
      //{ path: 'risk-radar', component: StrategicRiskDashboardComponent },
      { path: 'risk-reports', component: RiskReportsComponent },
      { path: 'risk-users', component: UserListComponent },
      { path: 'edit-user/:id', component: EditUserComponent },
      { path: 'horizon', component: HorizonScanningComponent },
      { path: 'horizon/:id', component: HorizonScanningDetailComponent },
      { path: 'add-horizon', component: HorizonScanningAddComponent },
      { path: 'add-horizon/:id', component: HorizonScanningAddComponent },
      //{ path: 'escalated', component: EscalatedRiskListComponent },
      //{ path: 'add-escalated', component: AddEscalatedRiskComponent },
      //{ path: 'edit-escalated/:id', component: EditEscalatedRiskComponent },

    ])
  ],
  exports: [MitigatingActionListComponent, RiskEventListComponent, RiskListComponent],
  entryComponents: [
    MitigationEditorComponent,
    RiskEventEditorComponent
  ],
  declarations: [MyRiskListComponent, RiskDetailsComponent, RiskImpactComponent, MitigatingActionComponent, MitigatingActionListComponent, RiskEventListComponent,
    RiskEventComponent, RiskImpactListComponent, EmergingRisksComponent, MyRiskEventListComponent, MyMitigatingActionListComponent, MitigationEditorComponent,
    RiskEventEditorComponent, PolicyGuidelineListComponent, PolicyGuidelineComponent, AddRiskComponent, EditRiskComponent, MitigationReviewComponent,
    AddUserComponent, EditUserComponent, UserListComponent, RiskListComponent, StrategicRiskDashboardComponent, RiskReportsComponent, RiskAuditListComponent,
    RiskAuditDetailsComponent, HorizonScanningComponent, HorizonScanningDetailComponent, HorizonScanningAddComponent, EscalatedRiskListComponent, AddEscalatedRiskComponent, EditEscalatedRiskComponent,
    RiskProbabilityPipe, RiskImpactPipe, MitigationReviewFormComponent
  ],
  providers: [RiskService, RiskCacheService]
})
export class RiskModule { }
